import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import ResultTable from "../Results/ResultTable";
import "moment/locale/sv";

export default function ProgramResultOverview(props) {
  moment.locale("sv");

  let columnExtensions = [
    { columnName: "name", width: 260 },
    { columnName: "avgScore", width: 250 },
    { columnName: "avgPercDone", width: 250 },
    { columnName: "avgNumTries", width: 250 },
    { columnName: "avgActivityPoints", width: 260 },
    { columnName: "lastRun", width: 180 },
  ];

  let columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="avgModuleTestScore" />, name: "avgScore" },
    { title: <FormattedMessage id="avgPercDone" />, name: "avgPercDone" },
    { title: <FormattedMessage id="avgNumTries" />, name: "avgNumTries" },
    {
      title: <FormattedMessage id="avgActivityPoints" />,
      name: "avgActivityPoints",
    },
    { title: <FormattedMessage id="LastRun" />, name: "lastRun" },
  ];

  let resultTableData = [];

  props.coursesData.data.forEach((course) => {
    let courseToAdd = {
      name: course.courseName,
      id: "c" + course.id,
      parentId: null,
    };
    resultTableData.push(courseToAdd);
    course.classes.forEach((classRes) => {
      let classToAdd = {
        name: classRes.name,
        parentId: "c" + course.id,
        avgScore: classRes.averageScore,
        avgPercDone: classRes.donePercentage,
        avgNumTries: classRes.averageNumberOfTimes,
        avgActivityPoints: classRes.averageActivityPoints,
        lastRun:
          classRes.lastRun === null
            ? null
            : moment(classRes.lastRun).format("lll"),
      };
      resultTableData.push(classToAdd);
    });
  });

  return (
    <ResultTable
      level="Class"
      tableData={resultTableData}
      columnExtensions={columnExtensions}
      columns={columns}
    />
  );
}
